// import React, { useState } from 'react';

// const UploadBox = ({ label, onFileChange ,}) => {
//   const [fileName, setFileName] = useState('');

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       setFileName(file.name);
//       if (onFileChange) {
//         onFileChange(file);
//       }
//     }
//   };

//   return (
//     <div className="upload-box-container">
//       <label className="upload-label fts-15 common-text ftw-4 lt-gray">{label}</label>
//       <div className="upload-box">
//         <input type="file" onChange={handleFileChange} className="upload-input "id="file-upload"/>
//         <label htmlFor="file-upload" className="upload-placeholder common-text blue fts-15 ftw-4">
//         <div className="upload-icon">
//             <svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
//                 <path d="M21.5624 7.67866V7.4406C21.5117 5.4253 20.6657 3.51191 19.2092 2.11813C17.7527 0.724351 15.804 -0.0366149 13.7884 0.00135569C12.2873 -0.010893 10.8146 0.410901 9.54762 1.21598C8.28061 2.02106 7.27324 3.17512 6.64673 4.5393C4.88274 4.73607 3.25233 5.57347 2.06481 6.89263C0.877291 8.2118 0.215272 9.92095 0.204346 11.6958C0.206296 12.6363 0.393585 13.5671 0.755506 14.4351C1.11743 15.3031 1.64688 16.0913 2.3136 16.7546C2.98032 17.4178 3.77122 17.9432 4.6411 18.3006C5.51099 18.658 6.44278 18.8405 7.38322 18.8375H10.1729V17.3497H7.38322C5.94531 17.2719 4.59037 16.6518 3.5915 15.6146C2.59263 14.5773 2.0241 13.2 2.00051 11.7602C1.97692 10.3204 2.50003 8.92515 3.46439 7.85574C4.42875 6.78634 5.76265 6.12227 7.19724 5.99739H7.69567L7.86677 5.52871C8.32816 4.33035 9.1463 3.30251 10.2106 2.58408C11.275 1.86565 12.5342 1.49127 13.8182 1.51152C15.4392 1.47343 17.0096 2.07762 18.1871 3.19241C19.3646 4.3072 20.0537 5.84221 20.1043 7.46292C20.1143 7.66117 20.1143 7.8598 20.1043 8.05806L20.0448 8.59368L20.5284 8.81686C21.4636 9.2382 22.2252 9.96881 22.685 10.8858C23.1448 11.8027 23.2747 12.85 23.0529 13.8515C22.8311 14.853 22.2712 15.7476 21.4672 16.3847C20.6633 17.0218 19.6645 17.3626 18.6388 17.3497H14.6365V18.8375H18.6388C19.9618 18.847 21.2503 18.4154 22.3007 17.6108C23.351 16.8062 24.1032 15.6745 24.4386 14.3946C24.7739 13.1148 24.6732 11.7596 24.1523 10.5434C23.6315 9.32713 22.7201 8.31913 21.5624 7.67866Z" fill="#CDCDCD"/>
//                 <path d="M15.5886 14.2632C15.737 14.2656 15.8827 14.2235 16.007 14.1424C16.1313 14.0613 16.2285 13.9449 16.2861 13.8081C16.3437 13.6713 16.359 13.5204 16.3302 13.3748C16.3014 13.2292 16.2296 13.0956 16.1242 12.9911L12.4046 9.27148L8.68499 12.9911C8.56311 13.1334 8.49943 13.3165 8.50666 13.5037C8.51389 13.6909 8.59151 13.8685 8.72399 14.001C8.85648 14.1335 9.03409 14.2111 9.22132 14.2184C9.40854 14.2256 9.59161 14.1619 9.73392 14.04L11.6607 12.143V21.2561C11.6607 21.4534 11.7391 21.6426 11.8786 21.7821C12.0181 21.9217 12.2073 22 12.4046 22C12.6019 22 12.7911 21.9217 12.9306 21.7821C13.0702 21.6426 13.1485 21.4534 13.1485 21.2561V12.143L15.0604 14.0549C15.202 14.1915 15.3919 14.2663 15.5886 14.2632Z" fill="#CDCDCD"/>
//             </svg>
//         </div>
//         {fileName || (
//             <span className='common-text blue fts-13 ftw-4'>Browse File</span>
//         )}
//         </label>
//       </div>
//     </div>
//   );
// };

// export default UploadBox;



import React, { useState, useEffect } from 'react';
import './uploadbox.css';
const UploadBox = ({ label, onFileChange, error=[] }) => {
  const [previewUrl, setPreviewUrl] = useState();
  const [errors, setError] = useState([]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setError(null);

    if (file) {
      // Validate file size (5MB limit)
      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        setError('File size should be less than 5MB');
        return;
      }

      // Validate file type
      const allowedTypes = ['image/jpeg', 'image/png', 'image/svg+xml'];
      if (!allowedTypes.includes(file.type)) {
        setError('Please upload a JPEG, PNG, or SVG file');
        return;
      }

      // Create preview URL and trigger change handler
      setPreviewUrl(URL.createObjectURL(file));
      if (onFileChange) {
        onFileChange(file);
      }
    }
  };

  // Cleanup preview URL when component unmounts
  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const displayErrors = error ? [error] : errors;

  return (
    <div className="upload-box-container">
      <label className="upload-label fts-15 common-text ftw-4 lt-gray">{label}</label>
      <div className="upload-box">
        <input
          type="file"
          onChange={handleFileChange}
          className="upload-input"
          id="file-upload"
          accept="image/jpeg,image/png,image/svg+xml"
        />
        <label
          htmlFor="file-upload"
          className="upload-placeholder common-text blue fts-15 ftw-4"
        >
          <div className="upload-icon">
            {previewUrl ? (
              <img
                src={previewUrl}
                alt="image"
                className="round-img"
              />
            ) : (
              <svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.5624 7.67866V7.4406C21.5117 5.4253 20.6657 3.51191 19.2092 2.11813C17.7527 0.724351 15.804 -0.0366149 13.7884 0.00135569C12.2873 -0.010893 10.8146 0.410901 9.54762 1.21598C8.28061 2.02106 7.27324 3.17512 6.64673 4.5393C4.88274 4.73607 3.25233 5.57347 2.06481 6.89263C0.877291 8.2118 0.215272 9.92095 0.204346 11.6958C0.206296 12.6363 0.393585 13.5671 0.755506 14.4351C1.11743 15.3031 1.64688 16.0913 2.3136 16.7546C2.98032 17.4178 3.77122 17.9432 4.6411 18.3006C5.51099 18.658 6.44278 18.8405 7.38322 18.8375H10.1729V17.3497H7.38322C5.94531 17.2719 4.59037 16.6518 3.5915 15.6146C2.59263 14.5773 2.0241 13.2 2.00051 11.7602C1.97692 10.3204 2.50003 8.92515 3.46439 7.85574C4.42875 6.78634 5.76265 6.12227 7.19724 5.99739H7.69567L7.86677 5.52871C8.32816 4.33035 9.1463 3.30251 10.2106 2.58408C11.275 1.86565 12.5342 1.49127 13.8182 1.51152C15.4392 1.47343 17.0096 2.07762 18.1871 3.19241C19.3646 4.3072 20.0537 5.84221 20.1043 7.46292C20.1143 7.66117 20.1143 7.8598 20.1043 8.05806L20.0448 8.59368L20.5284 8.81686C21.4636 9.2382 22.2252 9.96881 22.685 10.8858C23.1448 11.8027 23.2747 12.85 23.0529 13.8515C22.8311 14.853 22.2712 15.7476 21.4672 16.3847C20.6633 17.0218 19.6645 17.3626 18.6388 17.3497H14.6365V18.8375H18.6388C19.9618 18.847 21.2503 18.4154 22.3007 17.6108C23.351 16.8062 24.1032 15.6745 24.4386 14.3946C24.7739 13.1148 24.6732 11.7596 24.1523 10.5434C23.6315 9.32713 22.7201 8.31913 21.5624 7.67866Z" fill="#CDCDCD"/>
                <path d="M15.5886 14.2632C15.737 14.2656 15.8827 14.2235 16.007 14.1424C16.1313 14.0613 16.2285 13.9449 16.2861 13.8081C16.3437 13.6713 16.359 13.5204 16.3302 13.3748C16.3014 13.2292 16.2296 13.0956 16.1242 12.9911L12.4046 9.27148L8.68499 12.9911C8.56311 13.1334 8.49943 13.3165 8.50666 13.5037C8.51389 13.6909 8.59151 13.8685 8.72399 14.001C8.85648 14.1335 9.03409 14.2111 9.22132 14.2184C9.40854 14.2256 9.59161 14.1619 9.73392 14.04L11.6607 12.143V21.2561C11.6607 21.4534 11.7391 21.6426 11.8786 21.7821C12.0181 21.9217 12.2073 22 12.4046 22C12.6019 22 12.7911 21.9217 12.9306 21.7821C13.0702 21.6426 13.1485 21.4534 13.1485 21.2561V12.143L15.0604 14.0549C15.202 14.1915 15.3919 14.2663 15.5886 14.2632Z" fill="#CDCDCD"/>
              </svg>
            )}
          </div>
          {previewUrl ? (
            <span className="file-name">Selected File</span>
          ) : (
            <span className="common-text blue fts-13 ftw-4">Browse File</span>
          )}
        </label>
      </div>
      {displayErrors.length > 0 && (
        <div className="input-error-message">
          {displayErrors[0]}
        </div>
      )}
    </div>
  );
};

export default UploadBox;